var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.modalComponent,{tag:"component",attrs:{"coupon":_vm.coupon}})}
var staticRenderFns = []

export { render, staticRenderFns }